import { createSelector } from '@ngrx/store';
import { selectSearchResponseById } from '@usf/ngrx-product';
import { productWithAlternativesSelector } from '../../shared/selectors/product.selectors';
import { NewSearchViewModel } from '../models/new-search-view.model';
import { SearchResultViewModel } from '@search/shared/models/search-view.model';
import { selectedCustomer } from '@app/ngrx-customer/store';
import { FacetValue } from '@usf/product-types';
import { FacetFilter } from '../models/facet-filter.model';

export const newSearchViewModelSelector = (correlationId: string) =>
  createSelector(
    selectSearchResponseById(correlationId),
    productWithAlternativesSelector,
    selectedCustomer,
    (searchResponse, productsMap, selectedCustomer): NewSearchViewModel => {
      let products: SearchResultViewModel[];

      if (
        !!searchResponse?.productNumbers &&
        searchResponse.productNumbers.every(
          productNumber => productsMap.get(productNumber) !== undefined,
        )
      ) {
        products = searchResponse.productNumbers.map((productNumber, index) => {
          const product = productsMap.get(productNumber);
          if (
            product?.summary?.properties &&
            product?.summary?.additionalProperties
          ) {
            product.summary.properties = new Set([
              ...product.summary.properties,
              ...product.summary.additionalProperties,
            ]);
          }
          return {
            ...product,
            selectedCustomer,
            resultRank: index + 1,
          };
        });
      }

      let selectedFacetFilters: FacetFilter[] = [];
      searchResponse?.facets?.forEach(facet => {
        facet?.values?.forEach(facetValue => {
          selectedFacetFilters = [
            ...selectedFacetFilters,
            ...getSelectedFacetFilters(facetValue, facet?.fieldName),
          ];
        });
      });

      return {
        ...searchResponse,
        selectedFacetFilters,
        products,
      };
    },
  );

const getSelectedFacetFilters = (
  facetValue: FacetValue,
  fieldName: string,
): FacetFilter[] => {
  let selectedFacetFilters: FacetFilter[] = [];
  if (facetValue?.isApplied) {
    selectedFacetFilters = [{ fieldName, facetValue }];
  }
  if (!!facetValue?.childrenFacetValues) {
    facetValue?.childrenFacetValues?.forEach(childFacetValue => {
      selectedFacetFilters = [
        ...selectedFacetFilters,
        ...getSelectedFacetFilters(childFacetValue, fieldName),
      ];
    });
  }
  return selectedFacetFilters;
};
